import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8","key":"svg-0"}],["path",{"d":"M3 12h6","key":"svg-1"}],["path",{"d":"M6 9v6","key":"svg-2"}]]

const IconExposurePlus2 = createReactComponent('outline', 'exposure-plus-2', 'ExposurePlus2', __iconNode);

export default IconExposurePlus2;